/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs */

const en_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generates a scannable QR code on physical prints`)
};

const es_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera un código QR escaneable en impresiones físicas`)
};

const fr_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génère un code QR scannable sur les impressions physiques`)
};

const de_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzeugt einen scannbaren QR-Code auf physischen Drucken`)
};

const ja_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物理的な印刷物にスキャン可能なQRコードを生成します`)
};

const zh_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在实体印刷品上生成可扫描的二维码`)
};

const ar_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يولد رمز QR قابل للمسح الضوئي على المطبوعات المادية`)
};

const id_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghasilkan kode QR yang dapat dipindai pada cetakan fisik`)
};

const it_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera un codice QR scansionabile sulle stampe fisiche`)
};

const ru_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создает сканируемый QR-код на физических отпечатках`)
};

const pt_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gera um código QR digitalizável em impressões físicas`)
};

const ko_generates_a_scannable_qr_code_on_physical_prints_a = /** @type {(inputs: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실물 인쇄물에 스캔 가능한 QR 코드를 생성합니다`)
};

/**
* | output |
* | --- |
* | "Generates a scannable QR code on physical prints" |
*
* @param {Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const generates_a_scannable_qr_code_on_physical_prints_a = /** @type {((inputs?: Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generates_A_Scannable_Qr_Code_On_Physical_Prints_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "es") return es_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "fr") return fr_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "de") return de_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "ja") return ja_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "zh") return zh_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "ar") return ar_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "id") return id_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "it") return it_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "ru") return ru_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	if (locale === "pt") return pt_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
	return ko_generates_a_scannable_qr_code_on_physical_prints_a(inputs)
});